import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";
import { systems, levels } from "@/mocks/systems";
import { articles, featuredArticles } from "@/mocks/articles";
import { faqs } from "@/mocks/faqs";

const testimonials = [
  {
    name: "追更老读者·阿青",
    role: "追漫 3 年",
    text: "以前只看打斗，没注意到体系其实埋得很深。这个站把炼丹、针灸、功法的关系理顺了，再看新章节完全跟得上节奏。",
  },
  {
    name: "设定考据党·白榆",
    role: "同人作者",
    text: "六大境界的脉络梳理得很清楚，写同人文查设定方便多了，尤其是药园体系和丹药品阶的对应关系，帮了大忙。",
  },
  {
    name: "新入坑读者·小满",
    role: "刚追完 200 话",
    text: "一开始被一堆术语劝退，看完网站的名词解读就豁然开朗了。现在看漫画感觉完全不一样，推荐给同好。",
  },
];

export default function Home() {
  const featured = featuredArticles
    .map((id) => articles.find((a) => a.id === id))
    .filter((a): a is NonNullable<typeof a> => Boolean(a));

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "天才医仙漫画修炼体系站",
    description:
      "系统梳理天才医仙漫画的医术修炼体系，从炼丹、针灸到功法进阶，理清医仙之路的升级脉络与六大境界。",
    url: "https://healingway.github.io/",
  };

  return (
    <>
      <Navbar />
      <BackToTop />

      {/* ===== 首屏品牌介绍 ===== */}
      <section className="relative flex min-h-[560px] w-full items-center overflow-hidden md:min-h-[640px]">
        <img
          src="https://readdy.ai/api/search-image?query=%E5%8F%A4%E9%A3%8E%E5%B1%B1%E6%B0%B4%E4%BB%99%E9%9A%90%20%E4%BA%91%E9%9B%BE%E7%BC%AD%E7%BB%95%E5%B1%B1%E5%B3%B0%E5%8F%A4%E9%98%81%E4%B8%B9%E7%82%89%E6%B0%94%E6%81%AF%E4%B8%8E%E9%93%B6%E9%92%88%E7%81%B5%E5%85%89%20%E6%9A%96%E9%87%91%E8%89%B2%E4%BB%99%E9%9C%BE%E4%B8%8E%E7%8E%89%E9%9D%92%E7%BB%BF%E6%A0%91%E7%9F%B3%E4%BA%A4%E9%94%99%20%E5%9B%BD%E7%94%BB%E6%B0%B4%E5%A2%A8%E9%A3%8E%E6%A0%BC%E9%AB%98%E8%A7%84%E6%A0%BC%E6%85%A2%E7%94%BB%E9%A3%8E%20%E6%B7%B1%E6%B2%89%E5%AE%89%E8%AF%A6%E7%9A%84%E4%BB%99%E4%BE%A0%E6%B0%9B%E5%9B%B4&width=1600&height=900&seq=hero-tiancai-01&orientation=landscape"
          alt="天才医仙漫画医术修炼体系的水墨山水背景图"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

        <div className="container-site relative z-10 w-full py-24 md:py-28">
          <p className="inline-flex items-center gap-2 rounded-full bg-accent-500/90 px-4 py-1.5 text-sm font-medium text-foreground-950">
            <i className="ri-leaf-line text-base" aria-hidden="true"></i>
            医术修炼体系知识站
          </p>
          <h1 className="mt-6 max-w-3xl text-3xl font-bold leading-snug text-background-50 md:text-5xl">
            天才医仙漫画 · 医仙之路升级脉络全解
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
            从<strong className="font-semibold text-accent-200">炼丹</strong>、
            <strong className="font-semibold text-accent-200">针灸</strong>到
            <strong className="font-semibold text-accent-200">功法</strong>进阶，本站系统梳理漫画的医术修炼体系与六大境界，
            帮你理清主角如何一步步变强，看漫画、查设定、理脉络，这里全都有。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/xiulian"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-600"
            >
              查看修炼体系
              <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
            </Link>
            <Link
              to="/article/yi-xian-zhi-lu"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/70 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
            >
              先看六大境界
            </Link>
          </div>

          <dl className="mt-12 grid max-w-3xl grid-cols-3 gap-4">
            {[
              { num: "3", label: "大修炼体系" },
              { num: "6", label: "大境界阶段" },
              { num: "9", label: "转金丹品阶" },
            ].map((s) => (
              <div key={s.label} className="border-l-2 border-accent-400/70 pl-3">
                <dd className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{s.num}</dd>
                <dt className="mt-1 text-sm text-background-200/80">{s.label}</dt>
              </div>
            ))}
          </dl>
        </div>
      </section>

      {/* ===== 体系总览 ===== */}
      <section className="bg-background-50 py-14 md:py-20">
        <div className="container-site">
          <div className="max-w-2xl">
            <p className="text-sm font-medium uppercase tracking-wider text-primary-600">医术修炼体系</p>
            <h2 className="mt-2 text-2xl font-bold md:text-3xl">三大体系，共同撑起医仙之路</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              炼丹、针灸、功法共享同一套真气底层逻辑，只是输出形式不同。理解它们如何并行运作，就抓住了整套体系的主轴。
            </p>
          </div>

          <div className="mt-10 grid gap-6 md:grid-cols-3">
            {systems.map((s) => (
              <article
                key={s.key}
                className="group overflow-hidden rounded-lg border border-background-200/80 bg-background-100/60 transition-transform hover:-translate-y-1"
              >
                <div className="relative h-44 w-full overflow-hidden">
                  <img
                    src={s.image}
                    alt={`天才医仙漫画${s.name}体系的设定配图`}
                    className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-md bg-background-50/90 text-primary-700">
                    <i className={`${s.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-lg font-bold">{s.name}</h3>
                  <p className="mt-0.5 text-xs font-medium text-accent-700">{s.subtitle}</p>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ===== 修炼之路 ===== */}
      <section className="bg-background-100 py-14 md:py-20">
        <div className="container-site">
          <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
            <div className="max-w-2xl">
              <p className="text-sm font-medium uppercase tracking-wider text-primary-600">修炼之路</p>
              <h2 className="mt-2 text-2xl font-bold md:text-3xl">从凡人到医仙的六大境界</h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                每一境界都是医术与修为的双重跃升，环环相扣，构成完整的升级脉络。
              </p>
            </div>
            <Link
              to="/xiulian"
              className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
            >
              查看完整脉络 <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          <ol className="mt-10 space-y-4">
            {levels.map((lv) => (
              <li
                key={lv.order}
                className="flex flex-col gap-3 rounded-lg border border-background-200/80 bg-background-50 p-4 sm:flex-row sm:items-center sm:gap-5 sm:p-5"
              >
                <div className="flex shrink-0 items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 font-heading text-base font-bold text-foreground-950">
                    {lv.order}
                  </span>
                  <span className="whitespace-nowrap font-heading text-lg font-bold text-primary-800">{lv.name}</span>
                </div>
                <p className="text-sm leading-relaxed text-foreground-600">{lv.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* ===== 热门内容推荐 ===== */}
      <section className="bg-background-50 py-14 md:py-20">
        <div className="container-site">
          <div className="max-w-2xl">
            <p className="text-sm font-medium uppercase tracking-wider text-primary-600">热门专题</p>
            <h2 className="mt-2 text-2xl font-bold md:text-3xl">热门体系解读</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              由浅入深，帮你读懂炼丹、针灸、功法三大体系与医仙之路的每一个细节。
            </p>
          </div>

          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {featured.map((a) => (
              <Link
                key={a.id}
                to={`/article/${a.id}`}
                className="group overflow-hidden rounded-lg border border-background-200/80 bg-background-100/60 transition-transform hover:-translate-y-1"
              >
                <div className="relative h-36 w-full overflow-hidden">
                  <img
                    src={a.cover}
                    alt={a.title}
                    className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="p-4">
                  <span className="inline-flex rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-800">
                    {a.category}
                  </span>
                  <h3 className="mt-2.5 font-heading text-base font-bold leading-snug group-hover:text-primary-700">
                    {a.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{a.excerpt}</p>
                  <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                    <span>{a.date}</span>
                    <span className="inline-flex items-center gap-1">{a.readTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ===== 口碑 ===== */}
      <section className="bg-primary-700 py-14 md:py-20">
        <div className="container-site">
          <div className="max-w-2xl">
            <p className="text-sm font-medium uppercase tracking-wider text-accent-300">读者口碑</p>
            <h2 className="mt-2 text-2xl font-bold text-background-50 md:text-3xl">追漫读者怎么说</h2>
          </div>
          <div className="mt-10 grid gap-6 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-lg bg-primary-800/60 p-6">
                <i className="ri-double-quotes-l text-2xl text-accent-400" aria-hidden="true"></i>
                <blockquote className="mt-3 text-sm leading-relaxed text-primary-100">{t.text}</blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 font-heading text-sm font-bold text-foreground-950">
                    {t.name.charAt(0)}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-background-50">{t.name}</p>
                    <p className="text-xs text-primary-300">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* ===== FAQ 预览 ===== */}
      <section className="bg-background-50 py-14 md:py-20">
        <div className="container-site grid gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <p className="text-sm font-medium uppercase tracking-wider text-primary-600">常见问题</p>
            <h2 className="mt-2 text-2xl font-bold md:text-3xl">快速了解医仙之路</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于漫画剧情、修炼体系、境界顺序等高频问题，这里都给你答案。
            </p>
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
            >
              查看全部问答 <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          <div className="space-y-3 lg:col-span-3">
            {faqs.slice(0, 4).map((f) => (
              <details key={f.q} className="group rounded-lg border border-background-200/80 bg-background-100/60 p-4">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-3 text-sm font-medium text-foreground-900">
                  {f.q}
                  <i className="ri-add-line text-lg text-foreground-500 transition-transform group-open:rotate-45" aria-hidden="true"></i>
                </summary>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="relative overflow-hidden py-14 md:py-20">
        <img
          src="https://readdy.ai/api/search-image?query=%E5%8F%A4%E9%A3%8E%E4%BB%99%E5%B1%B1%E9%9B%BE%E9%9A%90%E4%B8%B9%E7%82%89%E9%93%B6%E9%92%88%E7%81%B5%E8%8D%89%E5%9B%BE%20%E6%9A%96%E9%87%91%E8%89%B2%E4%B8%8E%E7%8E%89%E9%9D%92%E7%BB%BF%E6%B0%B4%E5%A2%A8%E9%A3%8E%E6%85%A2%E7%94%BB%E8%83%8C%E6%99%AF%20%E6%B7%B1%E6%B2%89%E5%AE%89%E8%AF%A6%E7%9A%84%E4%BB%99%E4%BE%A0%E6%B0%9B%E5%9B%B4&width=1600&height=700&seq=cta-tiancai-01&orientation=landscape"
          alt="天才医仙漫画修炼体系的古风水墨配图"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/55"></div>
        <div className="container-site relative z-10 w-full py-10 text-center md:py-12">
          <h2 className="text-2xl font-bold text-background-50 md:text-3xl">想理清医仙之路的升级脉络？</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
            从淬体到医仙，从炼丹到针灸，一篇篇专题带你读懂《天才医仙漫画》的整套医术修炼体系。
          </p>
          <Link
            to="/xiulian"
            className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-600"
          >
            开始探索修炼体系
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
      </section>

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />

      <Footer />
    </>
  );
}